import { useNavigate } from 'react-router-dom';

import CompleteIcon from '@/assets/img/icon/complete.svg';
import ArrowRightIcon from '@/components/Icon/ArrowRightIcon';
import { useModalStore } from '@/store/modalStore';
import { useToastStore } from '@/store/toastStore';

import * as S from './style';

const AccountExit = () => {
	const navigate = useNavigate();
	const { openToast } = useToastStore();
	const { showModal } = useModalStore();
	const showToast = () => {
		openToast({
			content: `회원탈퇴가 완료되었습니다.\n잠시후 홈으로 이동합니다.`,
			subContent: '대한화장품학회',
			showTime: 3000,
		});
		showModal('입력하신 번호로 인증번호가 발송되었습니다.\n문자를 확인하신 후 인증번호를 입력해 주세요.');
	};
	return (
		<S.FormContainer>
			<S.Container>
				<S.ImgBox>
					<img src={CompleteIcon} alt="회원탈퇴 완료" />
				</S.ImgBox>
				<S.ContentBox>
					<S.Title>정말 회원탈퇴 하시겠습니까?</S.Title>
					<S.SubTitle>
						탈퇴시 회원님의 계정에 저장된 모든 정보가
						<br />
						영구삭제되며 복구되지 않습니다.
					</S.SubTitle>
				</S.ContentBox>
			</S.Container>
			<S.ButtonBox>
				<S.NextButton
					type="button"
					onClick={() => {
						navigate('/mypage', { state: { step: '기본정보' } });
					}}
				>
					취소
				</S.NextButton>
				<div className="button_wrap">
					<S.SecessionButton onClick={showToast}>
						회원탈퇴 <ArrowRightIcon width="16" height="16" iconColor="#495057" />
					</S.SecessionButton>
				</div>
			</S.ButtonBox>
		</S.FormContainer>
	);
};

export default AccountExit;
